<template>
  <div class="wrap">
    <div class="top pl-6 pr-6">
      <div class="top_main">
        <div class="top_main_header">
          <div class="inline-block mb-4">
            <p v-if="type == 'proxy'" class="text-medium-x inline-block font-bold">1.添加代理</p>
            <p v-else class="text-medium-x inline-block font-bold">1.添加调查员</p>
          </div>
          <div class="inline-block" v-if="(data && data.length > 0) || (data_proxy && data_proxy.length > 0)">
            <p class="inline-block">
              <el-row v-if="type == 'phone' || type == 'random'">
                <el-button type="primary" @click="dialogVisible = true">输入手机号添加</el-button>
                <el-button @click="openVisKu">从调查员库选择</el-button>
                <span style="color: rgba(0, 0, 0, 0.65); font-size: 14px; margin-left: 12px"
                  >已添加<span class="text-theme"> {{ data.length }}人 </span></span
                >
              </el-row>
              <el-row v-if="type == 'proxy'">
                <el-button type="primary" @click="openProxy">从代理库选择</el-button>
                <span style="color: rgba(0, 0, 0, 0.65); font-size: 14px; margin-left: 12px"
                  >已添加<span class="text-theme"> {{ data_proxy.length }}人 </span></span
                >
              </el-row>
            </p>

            <!-- <p class="inline-block ml-3" v-if="type !== 'phone'">
              <span class="text-theme-black-450 text-medium"
                ><span v-if="type == 'proxy'">代理</span><span v-else>调查员</span>不够？去</span
              >
              <el-button type="text" @click="toRecruit()" class="text-medium">任务广场招募</el-button>
            </p> -->
          </div>
        </div>
        <div
          v-if="(!data || data.length == 0) && (!data_proxy || data_proxy.length == 0)"
          class="top_empty_content flex items-center justify-center"
        >
          <div class="inline-block text-center">
            <div v-if="type == 'phone' || type == 'random'">
              <el-button type="primary" @click="dialogVisible = true">输入手机号添加</el-button>
              <el-button @click="openVisKu" class="btn-ml-6">从调查员库选择</el-button>
            </div>
            <div v-if="type == 'proxy'">
              <el-button type="primary" @click="openProxy">从代理库选择</el-button>
            </div>
            <!-- <div class="mt-4" v-if="type !== 'phone'">
              <div v-if="type==='proxy'"></div>
              <div v-else>
                <span class="text-theme-black-450 text-medium"
                  ><span v-if="type == 'proxy'">代理</span><span v-else>调查员</span>不够？去</span
                >
                <el-button type="text" @click="toRecruit()" class="text-medium">任务广场招募</el-button>
              </div>
            </div> -->
          </div>
        </div>
        <div v-else class="mt-1">
          <el-button class="btn-refresh" type="text" @click="refresh" v-if="!isOpen&&(type == 'phone' || type == 'random')">刷新</el-button>
          <div style="height: 300px;" v-if="!isTableShow">
          </div>
          <el-form class="add-visit-table" ref="taskRuleForm" v-if="isTableShow">
            <data-table
              v-if="type == 'phone' || type == 'random'"
              ref="crud1"
              cell-class-name="truncate-table-cell-wrap"
              height="300"
              :data="data"
              :columns="option_index.column"
              :loading="loading1"
              :selection="true"
              :isShowCheckCount="true"
              @selection-change="selectionChange"
              :page="page00"
            >
              <template #actionAreas="scope">{{ handleArea(scope.row) }}</template>
              <template #status="{ row }">
                <span v-if="row && row.status == 1">正常</span>
                <span v-if="row && row.status == 2">停用</span>
                <span v-if="row && row.status == 3">注销</span>
              </template>
              <template #opt="{ row }">
                <!-- <el-button type="text" size="small" @click="del(row)">删除</el-button> -->
                <ClickDelete title="调查员删除" @delFun="del(row)">
                  <p slot="content">调查员被删除后无法撤消，需要重新添加调查员</p>
                  <el-button type="text" size="small" slot="delBtn">删除</el-button>
                </ClickDelete>
              </template>
              <template #settleMethod="{ row, $index }">
                <el-form-item label="" :rules="[{ require: true, message: '请选择数据' }]">
                  <el-select v-model="row.settleMethod" placeholder="请选择" @change="val => changeProxySettleMode(val, row, $index)">
                    <el-option
                      v-for="item in settleMethodOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template #settleMode="{ row, $index }">
                <el-form-item label="" :rules="[{ require: true, message: '请选择数据' }]" class="s-m">
                  <div v-if="!isOpen&&(!row.settleMethod||row.settleMethod == 0)" class="flex">
                    <el-select disabled placeholder="未开通">
                      <el-option
                        :key="-1"
                        :label="'未开通'"
                        :value="-1">
                      </el-option>
                    </el-select>
                    <span class="text-yellow-theme ml-2 font-semibold text-small">
                      <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                      尚未开通，无法使用
                    </span>
                    <span class="cursor-pointer text-theme ml-1 text-small" @click="toOpen">去开通></span>
                  </div>
                  <!-- <template v-else-if="row.settleMethod == 2">
                    <span>无</span>
                  </template>
                  <template v-else> -->
                  <div class="flex items-center" v-else>
                    <span v-if="row.settleMethod == 2">执行数量，</span>
                    <el-select style="width:120px" v-model="row.settleMode" placeholder="请选择" @change="val => changeProxySettleMode(val, row, $index)">
                      <el-option
                        v-for="item in settleModeOptions.filter(it=>it.hideVal !==row.settleMethod)"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="row.settleMode" @change="val => changeProxySettleMode(val, row, $index)">
                      <el-radio :label="1">按答卷数量</el-radio>
                      <el-radio :label="2">按天</el-radio>
                      <el-radio :label="3">按阶梯计价</el-radio>
                    </el-radio-group> -->

                    <!-- 原数量expectedQuantity  -->
                    <div class="expectedQuantity ml-3" style="display: flex">
                      <span v-if="row.settleMode === 1 && row.settleMethod != 2">回收：</span>
                      <span v-if="row.settleMode === 2 && row.settleMethod != 2">工作：</span>
                      <span v-if="row.settleMethod == 2">执行：</span>
                      <el-form-item
                        label=""
                        :rules="[
                          { required: true, message: '请完善数据项', trigger: 'blur' },
                          { type: 'number', message: '必须为数字值' }
                        ]"
                      >
                        <el-input-number
                          controls-position="right"
                          style="background: #f2f5fa"
                          placeholder=""
                          v-model.number="row.settleRule.expectedQuantity"
                          :min="1"
                          :max="99999999"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin-left: 8px; line-height: 32px"> {{ row.settleMode === 1 ? '份' : '天' }}</span>
                    </div>
                    <!-- 原单价settlementPrice  -->
                    <div class="settlementPrice ml-3">
                      <div v-if="row.settleMode === 1 && row.settleMethod != 2" class="settlementType-style mt0">
                        <div class="flex-settlement">
                          <span style="">每份</span>
                          <el-form-item label="">
                            <el-input-number
                              controls-position="right"
                              placeholder=""
                              v-model.number="row.settleRule.unitPriceYuan"
                              autocomplete="off"
                              :min="1"
                              :max="99999999"
                              :precision="2"
                            >
                            </el-input-number>
                          </el-form-item>
                          <span style="margin-left: 8px; line-height: 32px">元</span>
                          <el-tooltip
                            effect="dark"
                            content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                            placement="top"
                          >
                            <div class="icon-wrap">
                              <span class="icon-font ico-tips">&#xe65b;</span>
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                      <div v-if="row.settleMode === 2 && row.settleMethod != 2" class="settlementType-style mt0">
                        <div class="flex-settlement">
                          <span style="">每天</span>
                          <el-form-item label="">
                            <el-input-number
                              controls-position="right"
                              placeholder=""
                              v-model.number="row.settleRule.unitPriceYuan"
                              autocomplete="off"
                              :min="1"
                              :max="99999999"
                              :precision="2"
                            >
                            </el-input-number>
                          </el-form-item>
                          <span style="margin-left: 8px; line-height: 32px">元</span>
                          <el-tooltip
                            effect="dark"
                            content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                            placement="top"
                          >
                            <div class="icon-wrap">
                              <span class="icon-font ico-tips">&#xe65b;</span>
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                      <div v-if="row.settleMode === 3 && row.settleMethod != 2" class="settlementType-style mt0">
                        <el-form-item label="">
                          <div class="flex-settlement" v-for="(item, index) in row.settleRule.tiers" :key="index">
                            <span style="margin-right: 8px" v-if="index === 0">每天</span>
                            <el-form-item>
                              <el-input-number
                                controls-position="right"
                                v-if="index === 0"
                                :disabled="true"
                                placeholder=""
                                v-model="item.quantityLowerBound"
                                autocomplete="off"
                                size="small"
                                :min="0"
                                :max="99999999"
                                :precision="0"
                              >
                              </el-input-number>
                              <el-input-number
                                v-if="index > 0"
                                controls-position="right"
                                :disabled="true"
                                placeholder=""
                                :value="row.settleRule.tiers[index - 1].quantityUpperBound * 1"
                                autocomplete="off"
                                :min="0"
                                :max="99999999"
                                :precision="0"
                              >
                              </el-input-number>
                            </el-form-item>
                            <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                            <el-form-item
                              label
                              :rules="[
                                { required: true, message: '请完善数据项', trigger: 'blur' },
                                { type: 'number', message: '必须为数字值' }
                              ]"
                            >
                              <el-input-number
                                controls-position="right"
                                placeholder=""
                                v-model.number="item.quantityUpperBound"
                                autocomplete="off"
                                :min="index > 0 ? row.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                                :max="99999999"
                                @change="val => currentInputNumber(val, item, index, $index)"
                                :precision="0"
                              >
                              </el-input-number>
                            </el-form-item>
                            <span style="margin: 0 0 0 8px">份</span>
                            <span style="margin: 0 8px 0 12px" v-if="row.settleMethod != 2">每份</span>
                            <el-form-item
                              v-if="row.settleMethod != 2"
                              label
                              :rules="[
                                {
                                  required: true,
                                  message: '请完善数据项',
                                  trigger: 'blur'
                                },
                                { type: 'number', message: '必须为数字值' }
                              ]"
                            >
                              <el-input-number
                                controls-position="right"
                                placeholder=""
                                v-model="item.unitPriceYuan"
                                autocomplete="off"
                                :min="1"
                                :max="99999999"
                                :precision="2"
                              >
                              </el-input-number>
                            </el-form-item>
                            <span v-if="row.settleMethod != 2" style="margin: 0 8px">元</span>

                            <span v-if="index === 0" class="iconfont btn-style" @click="handleSettlement('add', $index, index)"
                              >&#xe68c;</span
                            >
                            <span
                              v-else-if="index === row.settleRule.tiers.length - 1"
                              class="iconfont btn-style"
                              @click="handleSettlement('remove', $index, index)"
                              >&#xe68a;</span
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                  </div>
                  
                </el-form-item>
              </template>
              <!-- <template #expectedQuantity="{ row, $index }">
                <div style="display: flex">
                  <el-form-item
                    label=""
                    :rules="[
                      { required: true, message: '请完善数据项', trigger: 'blur' },
                      { type: 'number', message: '必须为数字值' }
                    ]"
                  >
                    <el-input-number
                      controls-position="right"
                      style="width: 66px; background: #f2f5fa"
                      placeholder=""
                      v-model.number="row.settleRule.expectedQuantity"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span style="margin-left: 8px; line-height: 32px"> {{ row.settleMode === 1 ? '份' : '天' }}</span>
                </div>
              </template> -->
              <!-- <template #headName>
                <div class="price-box">
                  单价（若用线上结算，请填写调查员到手金额，
                  <el-button type="text" @click="emitClick">计算器</el-button>
                  ）
                </div>
              </template> -->
              <!-- <template #settlementPrice="{ row, $index }">
                <div v-if="row.settleMode === 1" class="settlementType-style mt0">
                  <div class="flex-settlement">
                    <el-form-item label="">
                      <el-input-number
                        controls-position="right"
                        placeholder=""
                        v-model.number="row.settleRule.unitPriceYuan"
                        autocomplete="off"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px; line-height: 32px">元/份</span>
                    <el-tooltip
                      effect="dark"
                      content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="row.settleMode === 2" class="settlementType-style mt0">
                  <div class="flex-settlement">
                    <el-form-item label="">
                      <el-input-number
                        controls-position="right"
                        placeholder=""
                        v-model.number="row.settleRule.unitPriceYuan"
                        autocomplete="off"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px; line-height: 32px">元/天</span>
                    <el-tooltip
                      effect="dark"
                      content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="row.settleMode === 3" class="settlementType-style mt0">
                  <el-form-item label="">
                    <div class="flex-settlement" v-for="(item, index) in row.settleRule.tiers" :key="index">
                      <span style="margin-right: 8px" v-if="index === 0">每天</span>
                      <el-form-item>
                        <el-input-number
                          controls-position="right"
                          v-if="index === 0"
                          :disabled="true"
                          placeholder=""
                          v-model="item.quantityLowerBound"
                          autocomplete="off"
                          size="small"
                          :min="0"
                          :max="Infinity"
                          :precision="0"
                        >
                        </el-input-number>
                        <el-input-number
                          v-if="index > 0"
                          controls-position="right"
                          :disabled="true"
                          placeholder=""
                          :value="row.settleRule.tiers[index - 1].quantityUpperBound * 1"
                          autocomplete="off"
                          :min="0"
                          :max="Infinity"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                      <el-form-item
                        label
                        :rules="[
                          { required: true, message: '请完善数据项', trigger: 'blur' },
                          { type: 'number', message: '必须为数字值' }
                        ]"
                      >
                        <el-input-number
                          controls-position="right"
                          placeholder=""
                          v-model.number="item.quantityUpperBound"
                          autocomplete="off"
                          :min="index > 0 ? row.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                          :max="Infinity"
                          @change="val => currentInputNumber(val, item, index, $index)"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份，按完成量</span>
                      <el-form-item
                        label
                        :rules="[
                          {
                            required: true,
                            message: '请完善数据项',
                            trigger: 'blur'
                          },
                          { type: 'number', message: '必须为数字值' }
                        ]"
                      >
                        <el-input-number
                          controls-position="right"
                          placeholder=""
                          v-model="item.unitPriceYuan"
                          autocomplete="off"
                          :min="1"
                          :max="Infinity"
                          :precision="2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">元/份</span>

                      <span v-if="index === 0" class="iconfont btn-style" @click="handleSettlement('add', $index, index)"
                        >&#xe68c;</span
                      >
                      <span
                        v-else-if="index === row.settleRule.tiers.length - 1"
                        class="iconfont btn-style"
                        @click="handleSettlement('remove', $index, index)"
                        >&#xe68a;</span
                      >
                    </div>
                  </el-form-item>
                </div>
              </template> -->
              <template slot="page-left">
                <div class="inline-block">
                  <el-checkbox style="margin-right: 12px" @change="changeCheckbox" v-model="checked">选择全部</el-checkbox>
                  <el-button type="primary" @click="setupSettlement">设置结算</el-button>
                  <!-- <el-button type="primary" plain @click="amoutDel">删除</el-button> -->
                  <ClickDelete title="调查员删除" @delFun="amoutDel">
                    <p slot="content">调查员被删除后无法撤消，需要重新添加调查员</p>
                    <el-button type="primary" plain slot="delBtn" class="ml-2.5">删除</el-button>
                  </ClickDelete>
                </div>
              </template>
            </data-table>
          </el-form>
          <over-mask
            :dialogVisible="dialVisible"
            @handleClose="
              () => {
                dialVisible = false
              }
            "
          ></over-mask>
          <el-form class="add-visit-table" ref="proxyRuleForm">
            <data-table
              v-if="type == 'proxy'"
              ref="crud_proxy_list"
              height="300"
              cell-class-name="truncate-table-cell-wrap"
              rowKey="id"
              :data="data_proxy"
              :columns="option_proxy.column"
              :selection="true"
              :isShowCheckCount="true"
              @selection-change="proxySelectionChange"
              :page="page00"
            >
              <template #settleMode="{ row, $index }">
                <el-form-item label="" :rules="[{ require: true, message: '请填写数据' }]">
                  <el-radio-group v-model="row.settleMode" @change="val => changeProxySettleMode(val, row, $index)">
                    <el-radio :label="1">按答卷数量</el-radio>
                    <el-radio :label="2">按天</el-radio>
                    <el-radio :label="3">按阶梯计价</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <template #expectedQuantity="{ row }">
                <div style="display: flex">
                  <el-form-item
                    label=""
                    :rules="[
                      { required: true, message: '请完善数据项', trigger: 'blur' },
                      { type: 'number', message: '必须为数字值' }
                    ]"
                  >
                    <el-input-number
                      controls-position="right"
                      style="width: 66px; background: #f2f5fa"
                      placeholder=""
                      v-model.number="row.settleRule.expectedQuantity"
                      :min="1"
                      :max="99999999"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span style="margin-left: 8px; line-height: 32px"> {{ row.settleMode === 1 ? '份' : '天' }}</span>
                </div>
              </template>
              <template #headName>
                <div class="price-box">
                  单价（若用线上结算，请填写调查员到手金额，
                  <el-button type="text" @click="maskVisible = true">计算器</el-button>
                  ）
                </div>
              </template>
              <template #settlementPrice="{ row, $index }">
                <div v-if="row.settleMode === 1" class="settlementType-style mt0">
                  <div class="flex-settlement">
                    <el-form-item label="">
                      <el-input-number
                        controls-position="right"
                        placeholder=""
                        v-model.number="row.settleRule.unitPriceYuan"
                        autocomplete="off"
                        :min="1"
                        :max="99999999"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px; line-height: 32px">元/份</span>
                    <el-tooltip
                      effect="dark"
                      content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="row.settleMode === 2" class="settlementType-style mt0">
                  <div class="flex-settlement">
                    <el-form-item label="">
                      <el-input-number
                        controls-position="right"
                        placeholder=""
                        v-model.number="row.settleRule.unitPriceYuan"
                        autocomplete="off"
                        :min="1"
                        :max="99999999"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px; line-height: 32px">元/天</span>
                    <el-tooltip
                      effect="dark"
                      content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="row.settleMode === 3" class="settlementType-style mt0">
                  <el-form-item label="">
                    <div class="flex-settlement" v-for="(item, index) in row.settleRule.tiers" :key="index">
                      <span style="margin-right: 8px" v-if="index === 0">每天</span>
                      <el-form-item>
                        <el-input-number
                          controls-position="right"
                          v-if="index === 0"
                          :disabled="true"
                          placeholder=""
                          v-model="item.quantityLowerBound"
                          autocomplete="off"
                          size="small"
                          :min="0"
                          :max="99999999"
                          :precision="0"
                        >
                        </el-input-number>
                        <el-input-number
                          v-if="index > 0"
                          controls-position="right"
                          :disabled="true"
                          placeholder=""
                          :value="row.settleRule.tiers[index - 1].quantityUpperBound * 1"
                          autocomplete="off"
                          :min="0"
                          :max="99999999"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                      <el-form-item
                        label
                        :rules="[
                          { required: true, message: '请完善数据项', trigger: 'blur' },
                          { type: 'number', message: '必须为数字值' }
                        ]"
                      >
                        <el-input-number
                          controls-position="right"
                          placeholder=""
                          v-model.number="item.quantityUpperBound"
                          autocomplete="off"
                          :min="index > 0 ? row.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                          :max="99999999"
                          @change="val => currentInputNumber(val, item, index, $index)"
                          :precision="0"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">份，按完成量</span>
                      <el-form-item
                        label
                        :rules="[
                          {
                            required: true,
                            message: '请完善数据项',
                            trigger: 'blur'
                          },
                          { type: 'number', message: '必须为数字值' }
                        ]"
                      >
                        <el-input-number
                          controls-position="right"
                          placeholder=""
                          v-model="item.unitPriceYuan"
                          autocomplete="off"
                          :min="1"
                          :max="99999999"
                          :precision="2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span style="margin: 0 8px">元/份</span>

                      <span v-if="index === 0" class="iconfont btn-style" @click="handleSettlement('add', $index, index)"
                        >&#xe68c;</span
                      >
                      <span
                        v-else-if="index === row.settleRule.tiers.length - 1"
                        class="iconfont btn-style"
                        @click="handleSettlement('remove', $index, index)"
                        >&#xe68a;</span
                      >
                    </div>
                  </el-form-item>
                </div>
              </template>
              <template #opt="scope">
                <!-- <el-button slot="reference" type="text" size="small" @click="del(scope.row)">删除</el-button> -->
                <ClickDelete title="代理删除" @delFun="del(scope.row)">
                  <p slot="content">代理被删除后无法撤消，需要重新添加代理</p>
                  <el-button slot="delBtn" type="text" size="small">删除</el-button>
                </ClickDelete>
              </template>
              <template slot="page-left">
                <div class="inline-block">
                  <el-checkbox style="margin-right: 12px" @change="proxyChangeCheckbox" v-model="proxyChecked"
                    >选择全部</el-checkbox
                  >
                  <el-button type="primary" @click="setupSettlement">设置结算</el-button>
                  <!-- <el-button type="primary" plain @click="amoutDelProxy">删除</el-button> -->
                  <ClickDelete title="代理删除" @delFun="amoutDelProxy">
                    <p slot="content">代理被删除后无法撤消，需要重新添加代理</p>
                    <el-button type="primary" plain slot="delBtn" class="ml-2.5">删除</el-button>
                  </ClickDelete>
                </div>
              </template>
            </data-table>
          </el-form>
          <!-- <div class="mt-2">
            已选择
            <span style="color: rgb(77, 170, 255)"> {{ selectLength }}</span> 人
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      title="批量输入手机号添加调查员"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
      top="0"
      width="766px"
      class="theme-dialog dialog-center dialog-body-0 split-line-footer-dialog"
    >
      <div class="pwd-notice px-6 bg-eee text-small leading-22 text-theme-black-650 py-1">
        <div>
          格式：<span class="text-theme-black-850 font-medium">调查员手机号</span> 或
          <span class="text-theme-black-850 font-medium">调查员手机号 + 逗号 + 调查员姓名</span>
        </div>
        <div>
          示例：<span class="text-theme-black-850 font-medium">15122223333</span> 或
          <span class="text-theme-black-850 font-medium">15122223333，张三</span> 
          <!-- 或 <span class="text-theme-black-850 font-medium">座机 010- 、 (010) 格式开头<span class="text-theme">【注：添加样本可填座机、添加调研员暂时不能】</span></span> -->
        </div>
      </div>
      <div v-show="errorMsgVisible"
        class="px-4 py-2 text-danger"
        style="background-color: rgb(252, 241, 240);">
        <span>错误信息（{{ errorType === '1' ? '姓名包含特殊字符【不能含有数字、字母、中文以外其他字符】' : '号码格式错误【手机号1开头且11位数字，座机需要按照座机号码规则等】' }}）：</span><br />
        <div class="leading-tight inline-block" v-html="errMsgArr.join('<br />')"></div>
        <el-button type="text" @click="delErrorData">删除错误数据</el-button>
      </div>

      <div class="input-box p-6 pt-4">
        <el-input
          type="textarea"
          v-loading="inpLoading"
          :rows="15"
          resize="none"
          placeholder="一个调查员一行，例如：
15122223333
15122223333，张三
15888888888，李四
15999999999"
v-model="inputValue"
></el-input>
<!-- 010-12345678,王五
(010)2345678,赵六" -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="inputCancel" size="mini">取 消</el-button>
        <el-button type="primary" @click="inputConfirm" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="从调查员库选择"
      class="theme-dialog dialog-center dialog-body-0"
      top="0"
      :visible.sync="dialogVisible1"
      width="70%"
      :modal="false"
      :destroy-on-close="true"
      :before-close="handleClose1"
    >
      <div class="px-6 py-4">
        <div class="inputGroup mb-2">
          <el-input placeholder="调查员姓名" v-model="visitorName" @change="searchName" style="width: 138px" clearable>
          </el-input>
          <el-input
            class="ml-3"
            placeholder="调查员手机号"
            v-model="visitorPhone"
            @change="searchPhone"
            style="width: 138px"
            clearable
          >
          </el-input>
        </div>
        <data-table
          ref="crud"
          class="avue1"
          :page="page1"
          :showPage="true"
          :data="dialogData"
          :columns="option.column"
          :selection="true"
          @selection-change="dialogSelectionChange"
          :loading="loading"
          rowKey="id"
          :isShowCheckCount="true"
          @size-change="sizeChange"
          @pagination-current-change="currentChange"
          :height="'45vh'"
        >
          <template #actionAreas="scope">{{ handleArea(scope.row) }}</template>
          <template #status="{ row }">
            <span v-if="row && row.status == 1">正常</span>
            <span v-if="row && row.status == 2">停用</span>
            <span v-if="row && row.status == 3">注销</span>
          </template>
          <template slot="empty">
            <div>调查员库中还未添加调查员</div>
          </template>
        </data-table>
      </div>
      <div class="btn-footer">
        <el-button @click="dialogCancel" style="width: 66px">取消</el-button>
        <el-button type="primary" @click="dialogConfirm" style="width: 66px">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="从代理库选择"
      :visible.sync="visibleProxy"
      :modal="false"
      class="theme-dialog dialog-center dialog-body-0"
      top="0"
      :destroy-on-close="true"
      width="70%"
    >
      <div class="px-6 py-4">
        <div class="inputGroup mb-2">
          <el-input placeholder="代理名称" v-model="visitorNameProxy" @change="searchNameProxy" style="width: 138px" clearable>
          </el-input>
          <!-- <el-input
            class="ml-3"
            placeholder="代理手机号"
            v-model="visitorPhoneProxy"
            @change="searchPhoneProxy"
            style="width: 138px"
            clearable
          >
          </el-input> -->
        </div>
        <data-table
          v-if="type == 'proxy'"
          ref="crud_proxy"
          class="avue1"
          :data="data_proxyDia"
          :columns="option_proxyDia.column"
          :page="page1_Proxy"
          :showPage="true"
          :selection="true"
          :isShowCheckCount="true"
          rowKey="phone"
          @selection-change="dialogSelectionChangeProxy"
          @size-change="sizeChange_proxy"
          @pagination-current-change="currentChange_proxy"
          :height="'45vh'"
        >
        </data-table>
      </div>
      <div class="btn-footer">
        <el-button @click="dialogProxyCancel" style="width: 66px">取消</el-button>
        <el-button type="primary" @click="dialogProxyConfirm" style="width: 66px">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :modal="false" :visible.sync="visible">
      <p>确认删除？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="del1()">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :title="'任务广场招募' + (type == 'proxy' ? '代理' : '调查员')"
      :visible.sync="recruitDrawer"
      direction="rtl"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      :before-close="handleRecruitDrawerClose"
    >
      <RecruitmentForm
        @cancel="handleRecruitDrawerClose"
        :surveyId="GlobalConfig.getSurveyId()"
        :pageType="type == 'proxy' ? 'proxy' : 'visitor'"
      ></RecruitmentForm>
    </el-drawer>
    <settlement-dialog
      @closeDialog="() => (settlementVisible = false)"
      :settlementVisible="settlementVisible"
      @settleData="changeSettleData"
    >
    </settlement-dialog>
    <over-mask :dialogVisible="maskVisible" @handleClose="() => (this.maskVisible = false)"></over-mask>
    <AddInvestigator :visible="addInvestigatorVisible" @handleClose="handleInvestigatorClose"/>
  </div>
</template>
<script>
import ClickDelete from '@/components/PopConfirm.vue'
import differenceWith from 'lodash.differencewith'
import isEqual from 'lodash.isequal'
import { isNum } from '@/assets/js/utils'
import { isMobile, isLandline } from '@/assets/js/validate'
import { interviewerListByPhone, interviewerList, agencyListProxy, agencyTask } from '@/api/wenjuan/offline'
import { agencyListDl } from '@/api/wenjuan/publishQuestion'
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import RecruitmentForm from '@/views/survey/offline/components/RecruitmentForm.vue'
import AccountCalculator from '@/components/base/AccountCalculator.vue'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import SettlementDialog from '@/components/interview/settlement-dialog/index.vue'
import { getMyPayPlatform } from '@/api/cost-settlement/common.js'
import AddInvestigator from '@/components/interview/add-Investigator/AddInvestigator.vue'
import cloneDeep from 'lodash/cloneDeep'
import store from '@/store'

export default {
  components: { DataTable, RecruitmentForm, AccountCalculator, OverMask, SettlementDialog, ClickDelete, AddInvestigator },
  data() {
    return {
      isTableShow: true,
      recruitDrawer: false,
      GlobalConfig,
      dialogVisible: false,
      visitorList: [],
      data: [],
      dialogData: [],
      data_proxy: [],
      data_proxyDia: [],
      diaList: [],
      diaListProxy: [],
      dataCopy: [],
      hasDataCopy: [],
      visitorNameProxy: '',
      visitorPhoneProxy: '',
      hasDataCopy1: [],
      beforeSelect: [],
      delList: [],
      visitorName: '',
      visitorPhone: '',
      inputValue: '',
      visibleProxy: false,
      visitorName1: null,
      visitorPhone1: null,
      inpLoading: false,
      loading: true,
      loading1: false,
      visible: false,
      dialogVisible1: false,
      page00: {
        currentPage: 0,
        total: 0,
        pageSize: 10
      },
      page1: {
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      page1_Proxy: {
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      settleMethodOptions:[
        {
          label: '线上结算',
          value: 0
        },
        {
          label: '线下结算',
          value: 1
        },
        {
          label: '无需结算',
          value: 2
        }
      ],
      settleModeOptions:[
        {
          label: '按答卷数量',
          value: 1
        },
        {
          label: '按天',
          value: 2
        },
        {
          label: '按阶梯计价',
          value: 3,
          hideVal:2
        }
      ],
      option_index: {
        column: [
          {
            align: 'left',
            label: '调查员姓名',
            value: 'name',
            width: 90,
            tooltip: 'false'
          },
          {
            align: 'left',
            label: '手机号',
            value: 'phone',
            width: 130,
            tooltip: 'false'
          },
          // {
          //   align: 'left',
          //   label: '性别',
          //   value: 'genderStr',
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   label: '年龄',
          //   value: 'ageStr',
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   label: '执行地区',
          //   value: 'actionAreas',
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   label: '学历',
          //   value: 'educationStr',
          //   tooltip: 'false'
          // },
          {
            align: 'left',
            label: '结算类型',
            value: 'settleMethod',// null=0=线上，1=线下，2=无需结算
            width: 130,
            tooltip: 'false'
          },
          {
            align: 'left',
            label: '结算方式',
            value: 'settleMode',
            width: 1000,
            tooltip: 'false'
          },
          // {
          //   align: 'left',
          //   label: '数量',
          //   value: 'expectedQuantity',
          //   width: 180,
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   headName: 'headName',
          //   label: '单价',
          //   value: 'settlementPrice',
          //   width: 565,
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   label: '专业擅长',
          //   value: 'industryStr',
          //   tooltip: 'false'
          // },
          // {
          //   align: 'left',
          //   label: '状态',
          //   value: 'status',
          //   tooltip: 'false'
          // },
          {
            label: '操作',
            value: 'opt',
            width: 100,
            fixed: 'right'
          }
        ]
      },
      option: {
        column: [
          {
            label: '调查员姓名',
            value: 'name'
          },
          {
            label: '手机号',
            value: 'phone',
            width: 200
          },
          {
            label: '性别',
            value: 'genderStr'
          },
          {
            label: '年龄',
            value: 'ageStr'
          },
          {
            label: '执行地区',
            value: 'actionAreas'
          },
          {
            label: '学历',
            value: 'educationStr'
          },
          {
            label: '专业擅长',
            value: 'industryStr'
          }
        ]
      },
      option_proxy: {
        column: [
          {
            label: '代理名称',
            value: 'agentName',
            width: 160
          },
          // {
          //   label: '联系方式',
          //   value: 'contact'
          // },
          // {
          //   label: '来源',
          //   value: 'proxyJobName'
          // },
          {
            align: 'left',
            label: '结算方式',
            value: 'settleMode',
            width: 300
          },
          {
            align: 'left',
            label: '数量',
            value: 'expectedQuantity',
            width: 180,
            tooltip: 'false'
          },
          {
            align: 'left',
            headName: 'headName',
            label: '单价',
            value: 'settlementPrice',
            width: 565,
            tooltip: 'false'
          },
          {
            label: '操作',
            value: 'opt',
            width: 100,
            fixed: 'right'
          }
        ]
      },
      option_proxyDia: {
        column: [
          {
            label: '代理名称',
            value: 'agentName',
            width: 160
          }
          // {
          //   label: '联系方式',
          //   value: 'contact'
          // },
          // {
          //   label: '来源',
          //   value: 'proxyJobName'
          // }
        ]
      },
      // 选择全不去
      checked: false,
      proxyChecked: false,
      multipleList: [],
      proxyMultipleList: [], // 代理选中的数据
      dialVisible: false,
      settlementVisible: false, //设置结算弹窗
      maskVisible: false, //计算器弹窗
      isOpen: false,

      addInvestigatorVisible:false, // 新调查员库弹窗
      errorMsgVisible: false, // 错误提示
      errMsgArr: [], // 错误信息
      errorType: '', // '1' 电话姓名格式错误； '2' 电话错误
      commaReg: /[,|，]+/g, // 逗号查找
      nameCheckReg: /^[\w|\u4e00-\u9fa5|`|\-|=|\[|\]|;|'|\\|.|/|*|~|!|@|#|$|%|^|&|*|(|)|+|{|}|:|"|\||<|>|?|·|【|】|；|‘|。|、|~|！|@|#|￥|%|……|&|*|（|）|——|：|“|”|《|》|？]*$/, // 姓名验证正则
    }
  },
  props: {
    type: String,
    changeDialog: Function
  },
  methods: {
    refresh() {
      this.getMyPayPlatform()
    },
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    getMyPayPlatform() {
      getMyPayPlatform().then(res => {
        this.isOpen = res.data.data.status === 1 // 是否开通 boolean 0 未开通 1开通
        this.isTableShow = false 
        setTimeout(() => {
          this.isTableShow = true
        }, 10)
      })
      .catch(err => {
        console.log(err)
      })
    },
    toRecruit() {
      this.recruitDrawer = true
    },
    handleRecruitDrawerClose() {
      this.recruitDrawer = false
    },
    dialogSelectionChange(list) {
      console.log(list)
      this.diaList = list
    },
    dialogSelectionChangeProxy(list) {
      console.log(list)
      this.diaListProxy = list
    },
    sizeChange(val) {
      this.page1.pageSize = val
      this.getVistorKu()
    },
    sizeChange_proxy() {
      this.page1_Proxy.pageSize = val
      this.getProxyKu()
    },
    currentChange_proxy() {
      this.page1_Proxy.pageSize = val
      this.getProxyKu()
    },
    currentChange(val) {
      this.page1.currentPage = val
      this.getVistorKu()
    },
    selectionChange(list) {
      const afterSelect = differenceWith(list, this.beforeSelect, isEqual)
      this.visitorList = afterSelect
      this.$refs.crud1.toggleRowSelection(list, false)
      console.log('selectionChange:', list, this.data)
      this.multipleList = list
      this.checked = this.data.length === list.length ? true : false
      this.$emit('childData', this.data, list)
    },
    proxySelectionChange(list) {
      const filetActive = list
        .map(it => ({ id: it.id }))
        .map(it => Object.values(it))
        .flat(Infinity)
      console.log(filetActive, this.data_proxy)
      this.proxyMultipleList = list
      this.proxyChecked = this.data_proxy.length === list.length ? true : false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
          this.inputValue = ''
        })
        .catch(_ => {})
    },
    searchPhone() {
      this.page1.currentPage = 1
      this.getVistorKu()
    },
    searchPhoneProxy() {
      this.getProxyKu()
    },
    searchName() {
      this.page1.currentPage = 1
      this.getVistorKu()
    },
    searchNameProxy() {
      this.getProxyKu()
    },
    openVisKu() {
      // this.dialogVisible1 = true
      // this.page1.currentPage = 1
      // this.page1.pageSize = 10
      // this.getVistorKu()

      this.addInvestigatorVisible = true;

    },
    handleClose1(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
          this.diaList = []
        })
        .catch(_ => {})
    },
    getProxyKu() {
      const p = {
        name: this.visitorNameProxy,
        phone: this.visitorPhoneProxy,
        current: this.page1_Proxy.currentPage,
        size: this.page1_Proxy.pageSize,
        agentName: this.visitorNameProxy
      }
      // agencyListProxy(p)
      agencyListDl(p)
        .then(res => {
          // console.log(res)
          this.page1_Proxy.total = res.data.data.total
          // this.page1.pageSize = res.data.data.totalPages;
          this.data_proxyDia = res.data.data.records.map(it => ({
            ...it,
            settleMode: 1,
            settleRule: {
              unitPriceYuan: undefined, //单价 多少元/天  多少元/份
              expectedQuantity: undefined, // 数量 多少份 | 多少天
              tiers: [
                {
                  quantityLowerBound: 0,
                  quantityUpperBound: undefined,
                  unitPriceYuan: undefined
                }
              ]
            },
            unitPriceYuan: undefined,
            expectedQuantity: undefined
          }))
          this.$refs.crud_proxy.doLayout()
        })
        .catch(err => {
          console.log(err)
          this.$refs.crud_proxy.doLayout()
        })
    },
    //调取调查员库接口
    getVistorKu() {
      this.loading = true
      const p = {
        name: this.visitorName,
        phone: this.visitorPhone,
        current: this.page1.currentPage,
        size: this.page1.pageSize
      }
      interviewerList(p)
        .then(res => {
          console.log(res)
          this.page1.total = res.data.data.total
          // this.page1.pageSize = res.data.data.totalPages;
          console.log('dialogData:', res.data.data.records)
          // mock 三种结算方式数据
          if (res.data.data.records) {
            res.data.data.records = res.data.data.records.map(it => ({
              ...it,
              settleMode: 1,
              settleRule: {
                unitPriceYuan: undefined, //单价 多少元/天  多少元/份
                expectedQuantity: undefined, // 数量 多少份 | 多少天
                tiers: [
                  {
                    quantityLowerBound: 0,
                    quantityUpperBound: undefined,
                    unitPriceYuan: undefined
                  }
                ]
              },
              unitPriceYuan: undefined,
              expectedQuantity: undefined
            }))
          }
          // 填充空白内容
          res.data.data.records.forEach(it => {
            for(let key in it) {
              if(it[key] === '') it[key] = '-'
            }
          })

          this.dialogData = res.data.data.records
          this.loading = false
          this.$refs.crud.doLayout()
        })
        .catch(err => {
          this.$message.warning(err.message)
          this.loading = false
          this.$refs.crud.doLayout()
        })
    },
    // 删除代理
    amoutDelProxy() {
      console.log('删除代理数据')
      if (this.proxyMultipleList.length > 0) {
        // this.$msgbox({
        //   title: '代理删除',
        //   message: '代理被删除后无法撤消，需要重新添加代理',
        //   showCancelButton: true,
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消'
        // })
        //   .then(_ => {
        //     const newArr = differenceWith(this.data_proxy, this.proxyMultipleList, isEqual)
        //     this.data_proxy = newArr
        //     //清空之前遗留的选择状态
        //     // this.$refs.crud1.clearSelection()
        //     console.log()
        //     this.$refs.crud_proxy_list.clearSelection()
        //     // this.$refs.crud_proxy.clearSelection()
        //     this.proxyChecked = false
        //     this.data_proxy = []
        //     this.$message.success('删除成功')
        //   })
        //   .catch(_ => {})
        const newArr = differenceWith(this.data_proxy, this.proxyMultipleList, isEqual)
        this.data_proxy = newArr
        //清空之前遗留的选择状态
        // this.$refs.crud1.clearSelection()
        this.$refs.crud_proxy_list.clearSelection()
        // this.$refs.crud_proxy.clearSelection()
        this.proxyChecked = false
        this.data_proxy = []
        this.$message.success('删除成功')
      } else {
        this.$message.warning('当前未勾选，请勾选后重试')
      }
    },
    amoutDel() {
      if (this.visitorList.length > 0) {
        // this.$msgbox({
        //   title: '调查员删除',
        //   message: '调查员被删除后无法撤消，需要重新添加调查员',
        //   showCancelButton: true,
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消'
        // })
        //   .then(_ => {
        //     const newArr = differenceWith(this.data, this.visitorList, isEqual)
        //     this.data = newArr
        //     // this.dataCopy = newArr
        //     // this.beforeSelect = this.visitorList
        //     // this.visitorList = []
        //     //清空之前遗留的选择状态
        //     this.$refs.crud1.clearSelection()
        //     this.data = []
        //     this.$message.success('删除成功')
        //   })
        //   .catch(_ => {})

        const ids = this.visitorList.map(it=> (it.id))
        this.data = this.data.filter(it=> !ids.includes(it.id));
        this.$refs.crud1.clearSelection();
        this.$message.success('删除成功');

        // const newArr = differenceWith(this.data, this.visitorList, isEqual)
        // this.data = newArr
        // this.$refs.crud1.clearSelection()
        // this.data = []
        // this.$message.success('删除成功')
      } else {
        this.$message.warning('当前未勾选，请勾选后重试')
      }
    },
    // searchVisName() {
    //   this.hasDataCopy1 = [];
    //   if (this.visitorName1) {
    //     let data = this.data;
    //     for (let index = 0; index < data.length; index++) {
    //       if (this.visitorName1 == data[index].name) {
    //         this.hasDataCopy1.push(data[index]);
    //       }
    //     }
    //     this.hasDataCopy1 ? (this.data = this.hasDataCopy1) : (this.data = []);
    //   } else {
    //     if (this.visitorPhone1) {
    //       this.data = this.hasDataCopy;
    //     } else {
    //       this.data = this.dataCopy;
    //     }
    //   }
    // },
    // searchVisPhone() {
    //   this.hasDataCopy = [];
    //   if (this.visitorPhone1) {
    //     let data = this.data;
    //     for (let index = 0; index < data.length; index++) {
    //       if (this.visitorPhone1 == data[index].phone) {
    //         this.hasDataCopy.push(data[index]);
    //       }
    //     }
    //     this.hasDataCopy ? (this.data = this.hasDataCopy) : (this.data = []);
    //   } else {
    //     if (this.visitorName1) {
    //       this.data = this.hasDataCopy1;
    //     } else {
    //       this.data = this.dataCopy;
    //     }
    //   }
    // },
    handleArea(row) {
      if (row.actionAreas) {
        let area = row.actionAreas
        if (area.indexOf(',') !== -1) {
          let arr = area.split(',')
          let arr1 = []
          for (let index = 0; index < arr.length; index++) {
            arr1 += arr[index].substring(0, arr[index].indexOf('-')) + ','
          }
          let arr2 = arr1.slice(0, arr1.length - 1)
          return arr2
        } else {
          return row.actionAreas
        }
      } else {
        return '-'
      }
    },
    del(row) {
      // this.visible = true
      // this.delList = []
      // this.delList = row

      // this.$msgbox({
      //   title: '调查员删除',
      //   message: '调查员被删除后无法撤消，需要重新添加调查员',
      //   showCancelButton: true,
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消'
      // })
      //   .then(_ => {
      //     this.delList = []
      //     this.delList = row
      //     this.$message({
      //       type: 'success',
      //       message: '删除成功'
      //     })
      //     if (this.type == 'proxy') {
      //       const newArr = differenceWith(this.data_proxy, [this.delList], isEqual)
      //       this.data_proxy = newArr
      //       this.$refs.crud_proxy.toggleRowSelection(this.delList, false)
      //     } else {
      //       const newArr = differenceWith(this.data, [this.delList], isEqual)
      //       this.data = newArr
      //     }
      //     done()
      //   })
      //   .catch(_ => {})
      this.delList = []
      this.delList = row
      this.$message({
        type: 'success',
        message: '删除成功'
      })
      if (this.type == 'proxy') {
        const newArr = differenceWith(this.data_proxy, [this.delList], isEqual)
        this.data_proxy = newArr
        this.$refs.crud_proxy.toggleRowSelection(this.delList, false)
      } else {
        const newArr = differenceWith(this.data, [this.delList], isEqual)
        this.data = newArr
      }
      // done()
    },
    del1() {
      if (this.type == 'proxy') {
        const newArr = differenceWith(this.data_proxy, [this.delList], isEqual)
        this.data_proxy = newArr
        this.$refs.crud_proxy.toggleRowSelection(this.delList, false)
      } else {
        const newArr = differenceWith(this.data, [this.delList], isEqual)
        this.data = newArr
      }

      this.visible = false
    },
    inputCancel() {
      this.dialogVisible = false
      this.inputValue = ''
    },
    inputConfirm() {
      this.inpLoading = true
      // const phoneReg =/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      //输入手机号 自动去后台匹配姓名及其他信息 如果没有 则自动创建
      if (this.inputValue.length > 0) {
        let inputVal = this.inputValue
        //1. 判断是否有换行
        // let inputArr = inputVal.split('\n')
        // console.log(inputArr);
        // if(inputArr.length > 1){

        // }
        // if (inputVal.indexOf("\n") == -1) {
        //   this.$message.warning("当前输入的手机号格式错误");
        // }

        let arr = inputVal.split('\n').filter(Boolean) //去掉空行
        // 2. 逗号分组
        const commaReg = this.commaReg
        // 2-1. 手机/座机格式错误数组
        const isPhoneErrArr = arr.filter(item => {
          const phone = item.split(commaReg).filter(Boolean)[0]?.trim() ?? ''
          return !isMobile(phone) && !isLandline(phone)
        })
        if (isPhoneErrArr.length > 0) {
          this.inpLoading = false
          this.errorMsgVisible = true // 错误提示
          this.errMsgArr = isPhoneErrArr // 错误数据
          this.errorType = '2'
          // this.$message.warning('当前输入的手机号格式错误，以1开发头11位数字')
          return
        } else {
          this.errorMsgVisible = false // 错误提示
          this.errMsgArr = [] // 错误数据
        }

        // 2-2. 姓名(不一定输入) 格式错误数组
        const errNameArr = arr.filter(item => {
          const name = item.split(commaReg).filter(Boolean)[1]?.trim() ?? ''
          return !this.nameCheckReg.test(name.replace(/ /g,''))
        })
        if (errNameArr.length > 0) {
          this.inpLoading = false
          this.errorMsgVisible = true // 错误提示
          this.errMsgArr = errNameArr // 错误数据
          this.errorType = '1'
          // this.$message.warning('输入格式有误，姓名可以是中文和大小写字母')
          return
        } else {
          this.errorMsgVisible = false // 错误提示
          this.errMsgArr = [] // 错误数据
        }
        arr = arr.map(item => {
          item = item.split(commaReg).filter(Boolean)
          return { phone: item[0]?.trim(), name: item[1]?.trim() ?? '' }
        })
        interviewerListByPhone(arr)
          .then(res => {
            // 错误时直接关闭弹窗
            if(res.data.code !== 0) {
              this.$message.error(res.data.msg || '当前输入内容错误，请重新输入')
              this.inpLoading = false
              // this.dialogVisible = false // 后台报错也不关
              // this.inputValue = ''
              return
            }
            if(res.data.code === 0 && res.data.data.length === 0) {
              this.$message.error('未找到该调查员')
            }
            res.data.data &&
              res.data.data.forEach(it => {
                ;(it.settleMode = 1),(it.status = 1),
                  (it.settleRule = {
                    unitPriceYuan: undefined, //单价 多少元/天  多少元/份
                    expectedQuantity: undefined, // 数量 多少份 | 多少天
                    tiers: [
                      {
                        quantityLowerBound: '',
                        quantityUpperBound: undefined,
                        unitPriceYuan: undefined
                      }
                    ]
                  })
                  for(let i in it) {
                    if(it[i] === "") it[i] = "-"
                  }
                it.settleMethod = it.settleMethod || 0
              })
            if (this.data.length > 0) {
              this.loading1 = true
              this.delRepeat(res.data.data)
            } else {
              this.loading1 = true
              this.data = res.data.data
              this.dataCopy = res.data.data
              this.loading1 = false
            }
            this.inpLoading = false
            this.dialogVisible = false
            this.inputValue = ''
          })
          .catch(err => {
            this.$message.warning(err.message)
            this.inpLoading = false
            this.dialogVisible = false
            this.inputValue = ''
          })
      } else {
        this.$message.warning('当前未输入手机号')
        this.inpLoading = false
        this.dialogVisible = false
        this.inputValue = ''
      }
    },
    delErrorData() {
      if (this.inputValue.length > 0) {
        let inputVal = this.inputValue
        let arr = inputVal.split('\n').filter(Boolean) //去掉空行
        if(this.errorType === '1') { // 手机号、姓名格式错误
          const commaReg = this.commaReg
          const successArr = arr.filter(item => {
            const name = item.split(commaReg).filter(Boolean)[1]?.trim() ?? ''
            return this.nameCheckReg.test(name.replace(/ /g,''))
          })
          this.inputValue = successArr.join('\n')
        }
        if(this.errorType === '2') { // 手机号格式错误
          const isPhoneSuccessArr = arr.filter(item => {
            const phone = item.split(this.commaReg).filter(Boolean)[0]?.trim() || ''
            return isMobile(phone) || isLandline(phone)
          })
          this.inputValue = isPhoneSuccessArr.join('\n')
        }
      }
      this.errorMsgVisible = false
    },
    dialogCancel() {
      this.visitorName = ''
      this.visitorPhone = ''
      this.page1.currentPage = 0
      this.dialogVisible1 = false
    },
    dialogProxyCancel() {
      this.visitorNameProxy = ''
      this.visitorPhoneProxy = ''
      this.page1_Proxy.currentPage = 1
      this.visibleProxy = false
    },
    dialogProxyConfirm() {
      if (this.diaListProxy.length > 0) {
        // this.data_proxy = this.diaListProxy
        // 拼接原始已添加的数据与代理库选中的数据
        const resListProxy = [...this.data_proxy, ...this.diaListProxy]
        let hash = {}
        const resFilterProxy = resListProxy.reduce((preVal, curVal) => {
          hash[curVal.id] ? '' : (hash[curVal.id] = true && preVal.push(curVal))
          return preVal
        }, [])

        this.data_proxy = resFilterProxy
        this.visibleProxy = false
      } else {
        this.$message.warning('当前未勾选，请勾选后重试')
      }
    },
    dialogConfirm() {
      if (this.diaList.length > 0) {
        if (this.data.length > 0) {
          this.loading1 = true
          // let data = this.diaList
          // data.forEach( v => {
          //   //对从调查员库选择的数据 增加此属性辨识
          //    v.isSelect = true;
          // })
          let dia = this.diaList.map(it=>{
            it.settleMethod = 0
            return it
          })
          this.delRepeat(dia, 'ranOrPhone')
        } else {
          this.loading1 = true
          this.data = this.diaList.map(it=>{
            it.settleMethod = 0
            return it
          })
          this.dataCopy = this.diaList.map(it=>{
            it.settleMethod = 0
            return it
          })
          this.loading1 = false
        }
        this.dialogVisible1 = false
      } else {
        this.$message.warning('当前未勾选，请勾选后重试')
      }
    },
    delRepeat(list, type) {
      let json = list.concat(this.data) //两个数组对象合并
      //   console.log(json);
      let newJson = [] //盛放去重后数据的新数组
      for (const item1 of json) {
        let flag = true
        for (const item2 of newJson) {
          if (item1.phone == item2.phone) {
            flag = false
          }
        }
        if (flag) {
          newJson.push(item1)
        }
      }
      console.log('newJson', newJson, this.data)
      // return newJson;
      type == 'proxy' ? (this.data_proxy = newJson) : (this.data = newJson)
      // this.data = newJson;
      // this.dataCopy = newJson;
      this.loading1 = false
    },
    openProxy() {
      agencyListDl()
        .then(res => {
          if (res.data.data.records && res.data.data.records.length > 0) {
            this.visibleProxy = true
            this.getProxyKu()
          } else {
            const h = this.$createElement
            const that = this
            this.$msgbox({
              // dangerouslyUseHTMLString: true,
              message: h('p', { style: 'text-align:center;padding:30px 0' }, [
                h('span', null, '您还没有代理商,可前往'),
                h(
                  'span',
                  {
                    style: 'color:#2775E8;cursor: pointer;margin:0 5px',
                    on: {
                      click: () => {
                        that.$router.push({ path: '/more-app/agent-lib/agent-detail' })
                        that.$msgbox.close()
                      }
                    }
                  },
                  '代理商库'
                ),
                h('span', null, '邀请代理商')
              ]),
              title: '',
              showCancelButton: true,
              cancelButtonText: '暂不邀请',
              confirmButtonText: '前往代理商库'
              // type: 'error'
            })
              .then(() => {
                console.log(this.$router.push({ path: '/more-app/agent-lib/agent-detail' }))
              })
              .catch(() => {})
          }
        })
        .catch(err => {
          // alertMsg.call(this)
          this.$message({
            type: 'error',
            message: err.message
          })
        })

      // this.visibleProxy = true
      // this.getProxyKu()
    },
    // 全部选择切换
    changeCheckbox(val) {
      console.log(val)
      if (val) {
        this.$refs.crud1.toggleAllSelection()
      } else {
        this.$refs.crud1.clearSelection()
      }
    },
    // 代理表格全部选择切换
    proxyChangeCheckbox(val) {
      console.log(val)
      if (val) {
        this.$refs.crud_proxy_list.toggleAllSelection()
      } else {
        this.$refs.crud_proxy_list.clearSelection()
      }
    },
    // 佣金结算相关方法
    handleSettlement(type, rowIndex, index) {
      console.log(type, rowIndex, index)
      if (type === 'add') {
        const cloneData = this.type === 'proxy' ? [...this.data_proxy] : [...this.data]
        cloneData.forEach((it, i) => {
          if (rowIndex === i) {
            if (it.settleRule.tiers.length < 5) {
              if (
                it.settleRule.tiers[it.settleRule.tiers.length - 1].quantityUpperBound === undefined ||
                it.settleRule.tiers[it.settleRule.tiers.length - 1].unitPriceYuan === undefined
              ) {
                this.$message.error('请完善表单项')
              } else {
                const itCloneItem = it.settleRule.tiers
                it.settleRule.tiers = [
                  ...itCloneItem,
                  { quantityLowerBound: undefined, quantityUpperBound: undefined, unitPriceYuan: undefined }
                ]
              }
            } else {
              this.$message.error('最多可添加5条数据')
            }
          }
        })
        this.type === 'proxy' ? (this.data_proxy = cloneData) : (this.data = cloneData)
      } else if (type === 'remove') {
        const cloneData = this.type === 'proxy' ? [...this.data_proxy] : [...this.data]
        cloneData.forEach((it, i) => {
          if (rowIndex === i) {
            console.log(it)
            const itCloneItem = it.settleRule.tiers.filter((itItem, itIndex) => index !== itIndex)
            it.settleRule.tiers = [...itCloneItem]
          }
        })
        this.type === 'proxy' ? (this.data_proxy = cloneData) : (this.data = cloneData)
      }
    },
    submitTest() {
      console.log(this.data)
    },
    // 点击计算器按钮传递事件
    emitClick() {
      this.$emit('changeDialog', true)
    },
    // 设置结算
    setupSettlement() {
      const resultList = this.type === 'proxy' ? this.proxyMultipleList : this.multipleList
      const filetActive = resultList
        .map(it => (this.type === 'proxy' ? { id: it.id } : { id: it.id }))
        .map(it => Object.values(it))
        .flat(Infinity)
      if (filetActive instanceof Array && filetActive.length > 0) {
        this.settlementVisible = true
      } else {
        this.$message.error(this.type === 'proxy' ? '请选择代理' : '请选择调查员')
      }
    },
    // 批量结算传入data
    changeSettleData(settleData) {
      console.log('before:', this.data)

      const multiple = this.type === 'proxy' ? this.proxyMultipleList : this.multipleList
      const tableData = this.type === 'proxy' ? this.data_proxy : this.data

      const filetActive = JSON.parse(JSON.stringify(multiple))
        .map(it => (this.type === 'proxy' ? { id: it.id } : { id: it.id }))
        .map(it => Object.values(it))
        .flat(Infinity)

      const cloneSettleData = JSON.parse(JSON.stringify(settleData))
      const postData2 = JSON.parse(JSON.stringify(tableData)).map(it => ({
        ...it,
        settleMethod:filetActive.includes(this.type === 'proxy' ? it.id : it.id) ? cloneSettleData.settleMethod : it.settleMethod,
        settleMode: filetActive.includes(this.type === 'proxy' ? it.id : it.id) ? cloneSettleData.settleMode : it.settleMode,
        settleRule: filetActive.includes(this.type === 'proxy' ? it.id : it.id) ? cloneSettleData.settleRule : it.settleRule
      }))

      if (this.type === 'proxy') {
        this.data_proxy = JSON.parse(JSON.stringify(postData2))
      } else {
        this.data = JSON.parse(JSON.stringify(postData2))
      }
      this.settlementVisible = false
    },
    // 监听input number 值的改变
    currentInputNumber(val, item, index, rowIndex) {
      const cloneData = JSON.parse(JSON.stringify(this.type === 'proxy' ? this.data_proxy : this.data))
      // 表格操作的当前行数据
      const currentData = JSON.parse(JSON.stringify(cloneData.find((it, tableIndex) => tableIndex === rowIndex)))
      // 拷贝后的阶梯计价数据
      const baseSettleRule = JSON.parse(JSON.stringify(currentData.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > index) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      cloneData[rowIndex].settleRule = {
        ...cloneData[rowIndex].settleRule,
        tiers: baseSettleRule.tiers
      }
      if (this.type === 'proxy') {
        this.data_proxy = cloneData
      } else {
        this.data = cloneData
      }
    },
    // 监听代理切换结算方式方法
    changeProxySettleMode(val, row, index) {
      let copyRow = JSON.parse(JSON.stringify(row))
      copyRow = {
        ...copyRow,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
      if (this.type === 'proxy') {
        this.$set(this.data_proxy, index, copyRow)
      } else {
        this.$set(this.data, index, copyRow)
      }
    },
    // 关闭新版调查员库弹窗事件
    handleInvestigatorClose(visible,selectList=[]){
      this.addInvestigatorVisible = visible;
      const filterSelect = selectList.map(it=> ({
        name:it.investigator_name,
        phone:it.investigator_phone,
        id:it.id,
        settleMethod:0,
        settleMode:1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        },
        unitPriceYuan: undefined,
        expectedQuantity: undefined
      }))
      const cloneFilterSelect = cloneDeep(filterSelect);
      const beforeData = [...this.data];
      const concatData = [...beforeData,...cloneFilterSelect]; 
      let map = new Map();
      for (let item of concatData) {
          if (!map.has(item.id)) {
              map.set(item.id, item);
          };
      };
      // 合并去重后的数据
      let concatDataArr = [...map.values()];
      this.data = concatDataArr;
      
    }
  },
  watch: {
    data: {
      handler: function (val,oldVal) {
        this.page00.total = val.length;
        console.log('this.watch',val,oldVal)
        if(val.length < oldVal.length && oldVal.length > 0){
          this.multipleList = [];
          val.length > 0 && this.$refs.crud1.clearSelection();
        }
        // const filterIds = val.map(it=>(it.id));
        // this.multipleList = this.multipleList.filter(it=> filterIds.includes(it.id));
        this.$emit('childData', val, this.multipleList)
        this.checked = val.length === this.multipleList.length ? true : false
      },
      deep: true
    },
    data_proxy(val) {
      this.page00.total = val.length
      this.$emit('childData1', val)
    }
  },
  computed: {
    inputAllInput() {
      if (this.inputValue == '') {
        return 0
      } else {
        let newArr = []
        let a = this.inputValue.split('\n')
        for (let key in a) {
          //过滤掉因为误点产生的空数组
          if (a[key] === '') {
            continue
          } else {
            newArr.push(a[key])
          }
        }
        return newArr.length
      }
    },
    selectLength() {
      if (this.type == 'proxy') {
        return this.data_proxy.length
      } else {
        return this.data.length
      }
    }
  },
  mounted() {
    this.isOpen = this.$store.getters.settlementType !== 1
  }
}

</script>
<style lang="scss" scoped>
.wrap {
  .el-tag,
  .el-tag--medium,
  .el-tag--light {
    display: none;
  }
  .top {
    .top_main {
      .top_main_header {
        display: flex;
        justify-content: space-between;
      }
      .top_main_container {
        .inputGroup {
          display: flex;
          align-items: center;
          .el_input {
            width: 350px;
            margin-top: 20px;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .inputGroup {
    display: flex;
    align-items: center;
    .el_input {
      width: 350px;
      margin-top: 20px;
      margin-right: 20px;
    }
  }
  .inputb {
    ::v-deep .el-textarea__inner {
      height: 300px !important;
      overflow: auto;
    }
    .footTip {
      position: absolute;
      left: 400px;
      bottom: 90px;
    }
  }
}
.top_empty_content {
  @apply bg-card-bg-gray;
  height: 300px;
}
.btn-ml-6 {
  margin-left: 24px !important;
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.s-m {
  ::v-deep .el-form-item__content {
    //display: flex !important;
  }
}
</style>
<style lang="scss">
.add-visit-table {
  .el-radio-group .el-radio {
    margin-right: 10px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
    .el-form-item__content {
      .el-input-group {
        .el-input-group__append {
          padding: 0 10px;
        }
      }
    }
  }
  .el-table.data-table .el-table__cell {
    height: auto;
  }
  .el-table th.el-table__cell {
    overflow: auto;
  }
  .el-input-number {
    width: 88px;
    .el-input__inner {
      padding-left: 5px !important;
      padding-right: 25px !important;
    }
  }
  .el-input-number.is-controls-right .el-input__inner {
    background: #f2f5fa;
  }
  .el-input.is-disabled .el-input__inner {
    border-color: rgba(221, 221, 221, 1);
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    background: #f2f5fa;
    .el-icon-arrow-down,
    .el-icon-arrow-up {
      color: rgba(0, 0, 0, 0.65);
      border-color: rgba(221, 221, 221, var(--tw-border-opacity));
    }
  }
  .price-box {
    .fixed-box {
      display: none;
    }
    &:hover .fixed-box {
      display: block;
      width: 300px;
      height: auto;
      position: fixed;
      right: 300px;
      top: 117px;
      z-index: 999;
    }
  }
  .settlementType-style {
    // padding: 12px;
    background-color: transparent;
    // &:hover{
    //   background-color: #f5f7fa;
    // }
    .el-form-item {
      // margin-bottom: 10px;
      .el-form-item__content .el-input-group__append {
        padding: 0px 10px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .btn-style {
      margin-left: 16px;
      color: #6c748a;
      opacity: 0.45;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
    .settlement-tips {
      margin-left: 100px;
      font-size: 12px;
      .el-button {
        font-size: 12px;
      }
      &.left-0 {
        margin-left: 0;
      }
    }
    .flex-settlement {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .icon-wrap {
        margin-left: 10px;
        .ico-tips {
          color: rgba(0,0,0,0.35);
        }
      }
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
.btn-refresh {
  position: absolute;
  top: 115px;
  z-index: 100;
  left: 530px;
}
</style>
